export enum Regexp {
  Email = '^\\S+@\\S+\\.\\S+$',
}
